import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import Modal from 'src/components/UI/Modal/Modal'
import faqObj from 'training-lane-booking-shared/utilities/faqObj'
import textConstants from 'training-lane-booking-shared/utilities/text'
import faqModalClasses from './FaqModal.module.scss'

const FaqModal = () => {
    const targetSection = useSelector(
        state => state.utils.modalState.faq.props?.targetSection
    )

    const autoScrollRef = useCallback((node) => {
        if (node !== null) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {

                    node.scrollIntoView({
                        block: 'start',
                        inline: 'center',
                        behavior: 'smooth'
                    })

                    let lastPos = node.getBoundingClientRect().top
                    let framesSame = 0

                    const checkScrollFinished = () => {
                        if (!node) return

                        const currentPos = node.getBoundingClientRect().top

                        if (Math.abs(currentPos - lastPos) < 1) {
                            framesSame++

                            if (framesSame > 5) {
                                node.classList.add(faqModalClasses.highlight)
                                return
                            }
                        } else {
                            framesSame = 0
                            lastPos = currentPos
                        }

                        requestAnimationFrame(checkScrollFinished)
                    }

                    requestAnimationFrame(checkScrollFinished)
                })
            })
        }
    }, [])

    const renderAnswer = (answer, key) => {
        if (typeof answer === 'string') {
            return <p key={key}>{answer}</p>
        }

        if (answer.variant === 'category-heading') {
            return (
                <p
                    key={key}
                    className={faqModalClasses.faqModalAnswerCategory}
                >
                    {answer.text}
                </p>
            )
        }

        if (answer.variant === 'definition') {
            return (
                <p
                    key={key}
                    className={faqModalClasses.faqModalAnswerDefinition}
                >
                    <strong
                        className={
                            faqModalClasses.faqModalAnswerDefinitionHeading
                        }
                    >
                        {answer.heading}
                    </strong>
                    <br />
                    {answer.text}
                </p>
            )
        }

        return null
    }

    return (
        <Modal name='faq'>
            <h1>{textConstants.FAQ}</h1>
            <div className={faqModalClasses.faqModalWrapper}>
                {
                    faqObj.map((faq, i) => {
                        const isTarget = faq.id === targetSection

                        return (
                            <div key={i} ref={isTarget ? autoScrollRef : null}>
                                <p
                                    id={faq.id}
                                    className={faqModalClasses.faqModalQuestion}
                                >
                                    {faq.q}
                                </p>
                                {
                                    faq.a.map((a, j) => renderAnswer(a, j))
                                }
                            </div>
                        )
                    })
                }
            </div>
        </Modal>
    )
}

export default FaqModal
